import React from "react";

function CalendarIcon() {
  return (
    <span className="anticon anticon-calendar">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
      >
        <g
          fill="none"
          fillRule="evenodd"
          stroke="currentColor"
          strokeLinecap="square"
          strokeWidth="1.65"
        >
          <path d="M1 3.2h17.6v15.644H1zm17.6 3.667H1m3.911-3.911V1m9.778 1.956V1"></path>
          <path d="M12.733 12.733h1.956v1.956h-1.956z"></path>
        </g>
      </svg>
    </span>
  );
}

export default CalendarIcon;
